(function(angular){
    'use strict';

    angular.module('onvio.setup.notifications', [
    ]);
})(window.angular);
